import * as _ from 'lodash';
import * as React from 'react';
import { Button } from '../../components/ui/Button';
import { ButtonGroup } from '../../components/ui/ButtonGroup';
import { DataList, DataListRow } from '../../components/ui/DataList';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import { FlexRow, GridContainer } from '../../components/ui/Grid';
import { Popover } from '../../components/ui/Popover';
import { QuestionsPopover } from '../../components/ui/QuestionsPopover';
import { Tooltip } from '../../components/ui/Tooltip'
import { comparator } from '../../util/array'
import { HttpRequest } from '../../util/http';
import { StatusTypesEndpoint } from '../../util/http/endpoints';
import { IStatusTypes } from '../CoachingFormStatus/interfaces';
import { ICoachingData, ICoachingValue, IResolutionStatus } from './interfaces';
import { getActionStatusIcon } from './util';

type SortOrderType = 'asc' | 'desc'
type SortByType = keyof ICoachingValue

interface ICoachingFormContainerProps {
  data?: ICoachingData
  initalPerfectScoreFilter?: boolean
  initalWowFilter?: boolean
  initalActionItemFilter?: boolean
  initialSalesOpportunity?: boolean
  initialAttritionRisk?: boolean
}

interface ICoachingFormContainerState {
  selectedIdsForExport: number[]
  showExportFooter: boolean | undefined
  exportCountText: string
  sortOrder: SortOrderType
  sortBy: SortByType
  actionItemFilter: boolean
  wowFilter: boolean
  perfectScoreFilter: boolean
  statuses: IResolutionStatus[]
  statusTypes: IStatusTypes[]
  statusFilter?: number[]
  readFilter?: boolean
  data?: ICoachingData
}

export class CoachingFormContainer extends React.Component<ICoachingFormContainerProps, ICoachingFormContainerState> {
  static readonly sortOrderKey = 'coachingForm::sortOrder'
  static readonly sortByKey = 'coachingForm::sortBy'

  state: ICoachingFormContainerState = {
    selectedIdsForExport: [],
    showExportFooter: undefined,
    exportCountText: '',
    sortOrder: 'asc',
    sortBy: 'interviewDate',
    actionItemFilter: false,
    wowFilter: false,
    perfectScoreFilter: false,
    statuses: [],
    statusTypes: [],
  }

  lastData: ICoachingData
  $questionModal: JQuery<HTMLElement>
  childPopupListener = (msgEv: MessageEvent) => this.listenForChildPopupMessages(msgEv)

  componentWillMount() {
    this.state.data = this.props.data
    this.state.actionItemFilter = this.props.initalActionItemFilter
    this.state.wowFilter = this.props.initalWowFilter
    this.state.perfectScoreFilter = this.props.initalPerfectScoreFilter

    this.$questionModal = $('#questionModal')

    this.loadStatuses()

    window.addEventListener('message', this.childPopupListener)

    try {
      const sortBy = localStorage.getItem(CoachingFormContainer.sortByKey) as SortByType | null
      const sortOrder = localStorage.getItem(CoachingFormContainer.sortOrderKey) as SortOrderType | null

      if (sortBy !== null) {
        this.state.sortBy = sortBy
      }

      if (sortOrder !== null) {
        this.state.sortOrder = sortOrder
      }
    } catch { /**/ }

    this.sortAndFilterRows()
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.childPopupListener);
  }

  loadStatuses() {
    HttpRequest.fetch<IStatusTypes[]>(StatusTypesEndpoint)
      .then((statusTypes) => this.setState({ statusTypes }))

    HttpRequest.fetch<IResolutionStatus[]>('/scripts/coaching_form/status_get_all')
      .then((statuses) => this.setState({ statuses }))
  }

  listenForChildPopupMessages(msgEvent: MessageEvent) {
    console.log(msgEvent.data)
    if (msgEvent.data === 'refreshStatusSection') {
      this.loadStatuses()
    }
    if (typeof msgEvent.data.indexOf === 'function' && msgEvent.data.indexOf('updateActionAlert') !== -1) {
      const pcs = msgEvent.data.split('#');
      const id = pcs[1];
      const newAi = pcs[2];
      if (null != this.state.data && this.state.data.values.length > 0) {
        const values = this.state.data.values
        const value = values.find((s) => s.id.toString() === id)
        const valueIndex = values.findIndex((s) => s.id.toString() === id)
        if (typeof value === 'object') {
          value.ai = String(newAi)
          values[valueIndex] = value
        }
        this.state.data.values = values
        this.setState(this.state)
      }
    }
  }

  getStatus(value: ICoachingValue): number {
    const status = this.state.statuses.find((st) => (st.form === value.id))
    return (status) ? status.resolutionId : ((value.ai === '1') ? 0 : 3)
  }

  hasResolvedStatus(value: ICoachingValue): boolean {
    const resolvedType = this.state.statusTypes.find((st) => st.status.toLowerCase() === 'resolved')

    if (resolvedType) {
      const valueStatusType = this.getStatus(value)
      return (valueStatusType !== undefined && valueStatusType === resolvedType.id)
    }

    return false
  }

  getStatusName(value: ICoachingValue): IStatusTypes['status'] {
    if (this.state.statusTypes.length > 0) {
      const statusId = this.getStatus(value)
      const statusType = this.state.statusTypes.find((st) => (statusId !== undefined && statusId === st.id))

      if (statusType) {
        return statusType.status
      }
    }

    return ''
  }

  componentWillReceiveProps(nextProps: ICoachingFormContainerProps) {
    this.state.data = _.cloneDeep(nextProps.data)

    //KLUDGE: Temp Filter Fix -- remove when ids are unique
    const ids = []
    if (this.state.data) {
      this.state.data.values = this.state.data.values.filter((row) => {
        if (ids.indexOf(row.id) >= 0) {
          return false
        }

        ids.push(row.id)
        return true
      })
    }

    this.lastData = _.cloneDeep(this.state.data)

    this.state.selectedIdsForExport = []
    this.state.exportCountText = ''
    this.state.showExportFooter = undefined

    this.setState(this.state)
    this.sortAndFilterRows(nextProps)
  }

  sortAndFilterRows(props = this.props) {
    if (this.lastData !== undefined) {
      const { sortOrder, sortBy, readFilter, statusFilter } = this.state
      const { wowFilter, actionItemFilter, perfectScoreFilter } = this.state
      let values = _.clone(this.lastData.values)
      values = values.filter((v) => {
        const status = this.getStatus(v)
        const isRead = v.viewed.toLowerCase() === 'yes'
        const isActionItem = v.ai === '1'
        const hasWow = v.wow === '1'
        const hasPerfectScore = v.ps === '1'

        if (typeof readFilter === 'boolean' && readFilter !== isRead) {
          return false
        }

        if (actionItemFilter && !isActionItem) {
          return false
        }

        if (wowFilter && !hasWow) {
          return false
        }

        if (perfectScoreFilter && !hasPerfectScore) {
          return false
        }

        if (statusFilter !== undefined && status !== undefined && statusFilter.indexOf(status) === -1) {
          return false
        }

        return true
      })

      values.sort(comparator<ICoachingValue>(sortBy, sortOrder))

      this.state.data.values = values
      this.setState(this.state)
    }
  }

  toggleActionItemFilter(actionItemFilter = !this.state.actionItemFilter) {
    this.state.actionItemFilter = actionItemFilter
    this.setState({ actionItemFilter })

    if (!actionItemFilter) {
      // Remove status filter when actionItemFilter has been turned off
      const statusFilter = undefined
      this.state.statusFilter = statusFilter
      this.setState({ statusFilter })
    }

    this.sortAndFilterRows()
  }

  toggleWowFilter(wowFilter = !this.state.wowFilter) {
    this.state.wowFilter = wowFilter
    this.setState({ wowFilter })

    this.sortAndFilterRows()
  }

  togglePerfectScoreFilter(perfectScoreFilter = !this.state.perfectScoreFilter) {
    this.state.perfectScoreFilter = perfectScoreFilter
    this.setState({ perfectScoreFilter })

    this.sortAndFilterRows()
  }

  resetFilterAndSortState() {
    this.setState({
      sortOrder: 'asc',
      sortBy: 'interviewDate',
      actionItemFilter: false,
      wowFilter: false,
      perfectScoreFilter: false,
      readFilter: undefined,
      statusFilter: undefined
    }, () => { this.sortAndFilterRows() })
  }

  openQuestionModal() {
    this.$questionModal.modal('open')
  }

  openCoachingForm(value: ICoachingValue) {
    const { abbr_survey, id, ai } = value
    const isActionItem = ai === '1'
    const page = `coaching_form?back=co&survey=${abbr_survey}&id=${id}&ai=${isActionItem}`
    const options = 'width=800,height=800,scrollbars=1,resizable=1'
    const openedWindow = window.open(page, '', options)

    this.markCoachingFormAsRead(value)
  }

  markCoachingFormAsRead(value: ICoachingValue) {
    if (this.state.data !== undefined) {
      value.viewed = 'Yes'
      const valueIndex = this.state.data.values.findIndex((v) => v.id === value.id)

      if (valueIndex >= 0) {
        this.state.data.values[valueIndex] = value
        this.setState(this.state)
      }
    }
  }

  toggleSelectedForExport(value?: ICoachingValue) {
    const { selectedIdsForExport } = this.state

    if (value !== undefined) {
      const { id } = value
      const indexOfId = selectedIdsForExport.indexOf(id)

      if (indexOfId >= 0) {
        selectedIdsForExport.splice(indexOfId, 1)
      } else {
        selectedIdsForExport.push(id)
      }
    }

    const numChecked = selectedIdsForExport.length
    const showExportFooter = numChecked > 0

    const lastExportStr = this.state.exportCountText
    const numsFound = lastExportStr.match(/\d{1,5}/)
    const lastNum = Array.isArray(numsFound) ? Number(numsFound[0]) : 0

    if (!isNaN(lastNum) && lastNum < numChecked) {
      const setCount = (num: number, total: number) => {
        const exportStr = numChecked <= 1 ? 'Form' : (num + ' Forms')
        this.state.exportCountText = exportStr

        this.setState(this.state)

        if (num < total) {
          setTimeout(() => setCount(num + 1, total), 2)
        }
      }

      setCount(lastNum + 1, numChecked);
    } else {
      const exportStr = numChecked <= 1 ? 'Form' : (numChecked + ' Forms')
      this.state.exportCountText = exportStr

      this.setState(this.state)
    }

    this.setState({ selectedIdsForExport, showExportFooter })
  }

  isSelectedForExport(value: ICoachingValue) {
    const { id } = value
    const indexOfId = this.state.selectedIdsForExport.indexOf(id)

    return indexOfId >= 0
  }

  selectAllForExport() {
    if (this.state.data !== undefined) {
      const { values } = this.state.data
      const selectedIdsForExport = values.map((v) => v.id)

      this.setState({ selectedIdsForExport }, () => this.toggleSelectedForExport())

    }
  }

  selectNoneForExport() {
    const selectedIdsForExport = []

    this.setState({ selectedIdsForExport }, () => this.toggleSelectedForExport())
  }

  exportSelected() {
    const selectedSurveys = this.state.selectedIdsForExport.map((id) => {
      if (this.state.data !== undefined) {
        const value = this.state.data.values.find((v) => v.id === id)
        if (value !== undefined) {
          const { abbr_survey } = value

          this.markCoachingFormAsRead(value)

          return { abbr_survey, id }
        }
      }
    })

    localStorage.setItem('selectedSurveys', JSON.stringify(selectedSurveys))
    const page = 'coaching_form?back=co&loadSelectedSurveys=true'
    window.open(page, '', 'width=800,height=800,scrollbars=1,resizable=1')

    setTimeout(() => this.selectNoneForExport(), 1000)
  }

  setSortOrder(sortOrder: SortOrderType) {
    this.state.sortOrder = sortOrder
    this.setState({ sortOrder })

    localStorage.setItem(CoachingFormContainer.sortOrderKey, sortOrder)

    this.sortAndFilterRows()
  }

  setSortBy(sortBy: SortByType) {
    if (this.state.sortBy !== sortBy) {
      this.state.sortBy = sortBy
      this.setState({ sortBy })
      localStorage.setItem(CoachingFormContainer.sortByKey, sortBy)

      this.sortAndFilterRows()
    } else {
      this.setSortOrder(this.state.sortOrder === 'asc' ? 'desc' : 'asc')
    }
  }

  unreadFilterClicked() {
    let readFilter: boolean | undefined = false

    //toggle
    if (this.state.readFilter === false) {
      readFilter = undefined
    }

    this.state.readFilter = readFilter

    this.setState({ readFilter })
    this.sortAndFilterRows()
  }

  readFilterClicked() {
    let readFilter: boolean | undefined = true

    //toggle
    if (this.state.readFilter === true) {
      readFilter = undefined
    }

    this.state.readFilter = readFilter

    this.setState({ readFilter })
    this.sortAndFilterRows()
  }

  updateStatusFilter(statusFilter: number) {
    //Toggle filter off when same button pressed twice in a row
    //NOTE: If statusFiler is undefined, create array with new filter and set state
    if (this.state.statusFilter === undefined || this.state.statusFilter.length === 0) {
      this.setState({ statusFilter: [statusFilter] }, () => { this.sortAndFilterRows() })
    } else {
      const currentStatusFilter = this.state.statusFilter
      const index = currentStatusFilter.indexOf(statusFilter)
      if (index === -1) {
        currentStatusFilter.push(statusFilter)
      } else {
        currentStatusFilter.splice(index, 1)
      }

      if (currentStatusFilter.length === 0) {
        this.setState({ statusFilter: undefined }, () => { this.sortAndFilterRows() })
      } else {
        this.setState({ statusFilter: currentStatusFilter }, () => { this.sortAndFilterRows() })
      }
    }

  }

  getSortIconFor(sortBy: SortByType) {
    if (this.state.sortBy !== sortBy) {
      return null
    }

    return (
      <FontAwesomeIcon icon={this.state.sortOrder === 'desc' ? 'caret-down' : 'caret-up'} />
    )
  }

  render() {
    if (typeof this.state.data === 'object') {
      const { showExportFooter, exportCountText, sortOrder, sortBy, statusFilter } = this.state
      const { actionItemFilter, wowFilter, perfectScoreFilter, readFilter } = this.state
      const { values } = this.state.data
      const readFilterOn = readFilter === true
      const readFilterOff = readFilter === false
      let exportFooterClasses = 'export-footer'

      if (showExportFooter === true) {
        exportFooterClasses += ' show'
      } else if (showExportFooter === false) {
        exportFooterClasses += ' hide'
      }

      const styles = {
        margin: '2.1rem 0 1.68rem 0',
      }

      return (
        <GridContainer>
          <div className="row">
            <div className="col s12 m6"><h1 className="text-header">Coaching Forms</h1></div>
            <div className="col s12 m6" style={styles}><a className="right" href="Edit Status.pdf" target="_blank">Coaching Form Help</a></div>
          </div>
          <DataList className="coaching-list">
            <DataListRow>
              <section className="coaching-list-cell coaching-list-cell-28 coaching-list-sorting"></section>
              <section className="coaching-list-cell coaching-list-cell-65 coaching-list-sorting">
                <Button color="link-lc" onClick={() => this.setSortBy('interviewDate')}>
                  Date
                  {this.getSortIconFor('interviewDate')}
                </Button>
              </section>
              <section className="coaching-list-cell coaching-list-cell-125 coaching-list-sorting">
                <Button color="link-lc" onClick={() => this.setSortBy('organization')}>
                  Team
                  {this.getSortIconFor('organization')}
                </Button>
              </section>
              <section className="coaching-list-cell coaching-list-cell-125 coaching-list-sorting">
                <Button color="link-lc" onClick={() => this.setSortBy('survey')}>
                  Survey
                  {this.getSortIconFor('survey')}
                </ Button>
              </section>
              <section className="coaching-list-cell coaching-list-cell-200 coaching-list-sorting">
                <Button color="link-lc" onClick={() => this.setSortBy('response')}>
                  {this.state.data.question}
                  {this.getSortIconFor('response')}
                </Button>
              </section>
              <section className="coaching-list-cell coaching-list-cell-65 coaching-list-sorting">
                <Button color="link-lc" onClick={() => this.setSortBy('id')}>
                  ID
                  {this.getSortIconFor('id')}
                </Button>
              </section>
              <section className="coaching-list-cell-actions coaching-list-cell-actions-sorting">
                <QuestionsPopover questionId={this.state.data.q} statId={this.state.data.stat} dataUrl="get_categories" />
                <Popover className="ml-3" btnText="Filters" maxWidth={true}>
                  <FlexRow className="space-between mb-1">
                    <ButtonGroup className="margin-bottom">
                      <Button active={readFilterOff} onClick={() => this.unreadFilterClicked()}>
                        <FontAwesomeIcon icon="bookmark" fixedWidth />
                        <span>&nbsp;Unread</span>
                      </Button>
                      <Button active={readFilterOn} onClick={() => this.readFilterClicked()}>
                        <FontAwesomeIcon icon="bookmark" fixedWidth muted />
                        <span>&nbsp;Read</span>
                      </Button>
                    </ButtonGroup>
                    <ButtonGroup className="margin-bottom">
                      <Button id="resetFilterBtns" onClick={() => this.resetFilterAndSortState()}>
                        <FontAwesomeIcon icon="ban" fixedWidth muted />
                        <span>&nbsp;Reset</span>
                      </Button>
                    </ButtonGroup>
                    <ButtonGroup className="margin-bottom">
                      <Button active={actionItemFilter} onClick={() => this.toggleActionItemFilter()}>
                        <FontAwesomeIcon icon="exclamation-triangle" color="orange" fixedWidth />
                        <span>&nbsp;Action Alert</span>
                      </Button>
                      <Button active={wowFilter} onClick={() => this.toggleWowFilter()}>
                        <FontAwesomeIcon icon="star" color="yellow" fixedWidth />
                        <span>&nbsp;WOW</span>
                      </Button>
                      <Button active={perfectScoreFilter} onClick={() => this.togglePerfectScoreFilter()}>
                        <FontAwesomeIcon icon="check" color="green" fixedWidth />
                        <span>&nbsp;Perfect Score</span>
                      </Button>
                    </ButtonGroup>
                    <ButtonGroup className="margin-bottom">
                      {this.state.statusTypes.map((statusType) =>
                        <Button key={statusType.id} active={statusFilter !== undefined && statusFilter.indexOf(statusType.id) !== -1} onClick={() => this.updateStatusFilter(statusType.id)}>
                          {getActionStatusIcon(statusType.status)}
                          <span>&nbsp;{statusType.status}</span>
                        </Button>
                      )}
                    </ButtonGroup>
                  </FlexRow>
                </Popover>
              </section>
            </DataListRow>

            {values.map((row) => {
              const isResolved = this.hasResolvedStatus(row)
              const statusName = this.getStatusName(row)
              const isActionItem = row.ai === '1'
              const isWow = row.wow === '1'
              const isPerfectScore = row.ps === '1'

              return (
                <DataListRow key={row.id}>
                  <section className="coaching-list-cell coaching-list-cell-28">
                    <Tooltip position='right' text={row.viewed === 'Yes' ? 'Read' : 'Unread'}>
                      <FontAwesomeIcon icon="bookmark" muted={row.viewed === 'Yes'} fixedWidth />&nbsp;
                    </Tooltip>
                  </section>
                  <section className="coaching-list-cell coaching-list-cell-65">
                    <article>{row.interviewDate}</article>
                  </section>
                  <section className="coaching-list-cell coaching-list-cell-125">
                    <article>{row.organization}</article>
                  </section>
                  <section className="coaching-list-cell coaching-list-cell-125">
                    <article className="text-muted">{row.survey}</article>
                  </section>
                  <section className="coaching-list-cell coaching-list-cell-200">
                    <article className="text-muted">{row.response}</article>
                  </section>
                  <section className="coaching-list-cell coaching-list-cell-65">
                    <article className="text-muted">{row.id}&nbsp;</article>
                  </section>
                  <section className="coaching-list-cell-actions">
                    <article>
                      <Tooltip text={isActionItem ? 'Action Item' : 'Not an Action Item'}>
                        <FontAwesomeIcon icon="exclamation-triangle" color="orange" muted={!isActionItem} />
                      </Tooltip>
                      <Tooltip text={isWow ? 'WOW' : 'No WOW'}>
                        <FontAwesomeIcon icon="star" color="yellow" muted={!isWow} />
                      </Tooltip>
                      <Tooltip text={isPerfectScore ? 'Perfect Score' : 'Not a Perfect Score'}>
                        <FontAwesomeIcon icon="check" color="green" muted={!isPerfectScore} />
                      </Tooltip>
                      <Tooltip text={statusName}>
                        {getActionStatusIcon(statusName)}
                      </Tooltip>
                    </article>
                    {this.isSelectedForExport(row) ?
                      <Button color="link-hc" className="text-danger" onClick={() => this.toggleSelectedForExport(row)}>
                        <FontAwesomeIcon icon="cloud-download-alt" fixedWidth />
                        <span>&nbsp;Added to Export</span>
                      </Button>
                      :
                      <Button color="link-hc" onClick={() => this.toggleSelectedForExport(row)}>
                        <FontAwesomeIcon icon="plus" fixedWidth />
                        <span>&nbsp;&nbsp;Export to PDF&nbsp;&nbsp;</span>
                      </Button>
                    }

                    <Button color="link-hc" onClick={() => this.openCoachingForm(row)}>
                      <FontAwesomeIcon icon="search" fixedWidth />
                      <span>&nbsp;View</span>
                    </Button>
                  </section>
                </DataListRow>
              )
            })}
          </DataList>

          <footer className={exportFooterClasses}>
            <GridContainer>
              <a className="btn btn-link" onClick={() => this.selectNoneForExport()}>
                <FontAwesomeIcon icon="square" fixedWidth />
                <span>&nbsp;Select None</span>
              </a>
              <a className="btn btn-link" onClick={() => this.selectAllForExport()}>
                <FontAwesomeIcon icon="check-square" fixedWidth />
                <span>&nbsp;Select All</span>
              </a>
              <a className="btn btn-action btn-lg" onClick={() => this.exportSelected()}>
                <FontAwesomeIcon icon="cloud-download-alt" fixedWidth />
                <span>&nbsp;Export</span>
                <span>&nbsp;{exportCountText}</span>
              </a>
            </GridContainer>
          </footer>
        </GridContainer >
      )
    }

    return (
      <section className="containerv2">
        <h1 className="text-header">Coaching Forms</h1>
      </section>
    )
  }
}
